import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { resetGenerateCoverLetter, generateCoverLetter } from "./generate-cover-letter";

const initialState: ProcessingState = { processing: "idle" };

export const generateCoverLetterReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(generateCoverLetter.fulfilled, state => {
    return { ...state, processing: "success" };
  });
  builder.addCase(generateCoverLetter.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(generateCoverLetter.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetGenerateCoverLetter, () => {
    return initialState;
  });
});
